import { render, staticRenderFns } from "./Remains.vue?vue&type=template&id=42676d44&"
import script from "./Remains.vue?vue&type=script&lang=js&"
export * from "./Remains.vue?vue&type=script&lang=js&"
import style0 from "./Remains.vue?vue&type=style&index=0&id=42676d44&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports